import * as React from 'react';
import Illustration from './illustration-advice.svg';
import { ArticleParagraph2, UIText2 } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HomeownersBanner = function HomeownersBanner() {
  return /*#__PURE__*/_jsxs("section", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs(ArticleParagraph2, {
      textAlign: "center",
      children: ["\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442", ' ', /*#__PURE__*/_jsx(UIText2, {
        fontWeight: "700",
        display: "inline",
        children: "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"
      }), ' ', "\u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043F\u043E\xA0\u043E\u0434\u043D\u043E\u043C\u0443 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044E \u0432\xA0\u043A\u0430\u0436\u0434\u043E\u0439 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0436\u0438\u043B\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438"]
    }), /*#__PURE__*/_jsx("img", {
      width: "188px",
      height: "104px",
      src: Illustration,
      loading: "lazy"
    })]
  });
};